import { render, staticRenderFns } from "./QuoteEmbeddable.vue?vue&type=template&id=21f09e4a&"
import script from "./QuoteEmbeddable.vue?vue&type=script&lang=js&"
export * from "./QuoteEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports